import {Breadcrumbs, Btn, H6, Image} from "../../../../../AbstractElements";
import {getApplicationRoute} from "../../../../../Route/RouteIndex";
import UpdateUserForm from "../../../../Privilege/User/Component/UpdateUserForm";
import React, {useContext, useEffect, useRef, useState} from "react";
import {Card, CardBody, CardHeader, Col, Container, Modal, ModalBody, ModalFooter, ModalHeader, Row} from "reactstrap";
import Loader from "../../../../../Layout/Loader";
import {BootstrapTabContainer, BootstrapTabContent} from "../../../../../CommonElements/BootstrapTabs";
import ButtonIcon from "../../../../../CommonElements/ButtonIcon";
import axiosConfig from "../../../../../Config/axios";
import {useParams} from "react-router";
import {useNavigate} from "react-router-dom";
import BoardsTable from "../../../Board/Board/Component/BoardsTable";
import ParticipantsTable from "../../../Participant/Participant/Component/ParticipantsTable";
import WalletTransactionsTable from "../../../Wallet/WalletTransaction/Component/WalletTransactionsTable";
import WalletContext from "../../../Wallet/Context";
import type {WalletContextType} from "../../../Wallet/Context/WalletContext.types";
import AdminZoneWallet from "../../../Wallet/Component/AdminZoneWallet";
import {ActivityLog} from "../../../../SystemCore/ActivityLog";
import AuthorizationContext from "../../../../../_helper/Authorization";
import {Collector} from "../../Types/CollectorTypes";
import type {AuthorizationContextType} from "../../../../../_helper/Authorization/AuthorizationTypes";
import CollectorDashboard from "../Component/CollectorDashboard";
import ContactTable from "../../../../SystemCore/Contact/Component/ContactTable";
import ContactForm from "../../../../SystemCore/Contact/Component/ContactForm";
import MultimediaService from "../../../../SystemCore/Multimedia/Services/Multimedia.service";
import type {Contact, ContactTableRef} from "../../../../SystemCore/Contact/Types/ContactTypes";
import ProfileImage from "../../../../CommonComponents/Profiles/ProfileImage";
import {MultimediaTable} from "../../../../SystemCore/Multimedia";

interface collectorShowProps {

}

const CollectorShow = ({}: collectorShowProps) => {
    const [loaderVisibility, setLoaderVisibility] = useState(false);
    const [collector, setCollector] = useState<Collector | null>(null);
    const [url, setUrl] = useState<string>('');
    const [contactModalVisibility, setContactModalVisibility] = useState<boolean>(false);
    const [selectedContact, setSelectedContact] = useState<Contact | undefined>();
    const contactTableRef = useRef<ContactTableRef>(null);
    const params = useParams();
    const navigate = useNavigate();
    const authContext = useContext(AuthorizationContext) as AuthorizationContextType;
    const walletContext = useContext(WalletContext) as WalletContextType;
    const {errorHandler, hasPermission} = authContext || {};
    const {getWalletInformation} = walletContext || {};
    const collectorRoute = getApplicationRoute('collector', true);

    useEffect(() => {
        setLoaderVisibility(true);
        axiosConfig
            .get(`${getApplicationRoute('collector')}/${params.collector}`)
            .then((response: { data: { data: Collector; }; }) => {
                if (response?.data?.data) {
                    setCollector(response.data.data);
                } else {
                    navigate(collectorRoute);
                }
                setLoaderVisibility(false);
            })
            .catch((exception: any) => {
                errorHandler(exception);
                setLoaderVisibility(false);
                navigate(collectorRoute);
            });
    }, [params.collector]);

    const deleteCollector = (id?: number) => {
        if (!id) return;
        setLoaderVisibility(true);
        axiosConfig
            .delete(`${getApplicationRoute('collector')}/${id}`, {})
            .then((response: { data: { data: { id: number; }; }; }) => {
                if (response?.data?.data) {
                    navigate(collectorRoute);
                }
                setLoaderVisibility(false);
            })
            .catch((exception: any) => {
                errorHandler(exception);
                setLoaderVisibility(false);
            });
    }

    const contactModalToggle = () => {
        if (contactModalVisibility) {
            setSelectedContact(undefined);
        }
        setContactModalVisibility(!contactModalVisibility);
    };

    const addContact = (contact: Contact) => {
        contactTableRef.current?.addContact(contact);
        contactModalToggle();
    };

    const openContactEditModal = (contact: Contact) => {
        setSelectedContact(contact);
        setContactModalVisibility(true);
    };

    const profileImageUrl = url
        || MultimediaService.resolveMultimediaUrl(collector?.avatar)
        || require('../../../../../assets/images/user/7.jpg');

    return (
        <div>
            <Breadcrumbs mainTitle="Collector Profile" parent="Application"
                         subParentLink={`${getApplicationRoute('collector')}`}
                         subParent={'Collectors'} title={collector?.name}/>
            <Container fluid={true}>
                <div className="user-profile">
                    <Loader visibility={loaderVisibility}/>
                    <Row>
                        <Col sm='12' lg='3'>
                            <Card className='hovercard text-center'>
                                <CardHeader className='social-profile'>
                                    <div className='d-flex align-items-center gap-2'>
                                    </div>
                                </CardHeader>
                                <ProfileImage profileImageUrl={profileImageUrl} setUrl={setUrl} params={{
                                    link_type_key: 'user',
                                    link_type_id: collector?.user?.id,
                                    single: true,
                                    role: 'avatar',
                                }}/>
                                <div className='info'>
                                    <Row className='step3' data-intro='This is the your details'>
                                        <Col sm='12' lg='12' className='order-sm-0 order-xl-1'>
                                            <div className='user-designation'>
                                                <div className='title'>
                                                    <a>
                                                        {collector?.name}
                                                    </a>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col sm='6' lg='12' className='order-sm-1 order-xl-0'>
                                            <Row>
                                                <Col>
                                                    <div className='ttl-info text-center'>
                                                        <H6>
                                                            {collector?.nic}
                                                        </H6>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </div>
                                <CardBody>
                                    {collector?.pointWallet?.last_transaction && collector ? (
                                        getWalletInformation(collector?.pointWallet)) : null}

                                    {collector?.cashWallet?.last_transaction && collector ? (
                                        getWalletInformation(collector?.cashWallet)
                                    ) : null}

                                    {!(collector?.cashWallet || collector?.pointWallet) && (
                                        <AdminZoneWallet
                                            relationKey="collector"
                                            relationId={collector?.id || ''}
                                            onSuccess={() => setLoaderVisibility(true)}
                                        />
                                    )}
                                    <div className='social-network theme-form m-t-20'>
                                        <span className='f-w-600 text-danger'>Danger Zone</span>
                                        <ButtonIcon confirm={{confirm:true}} onclick={() => deleteCollector(collector?.id)}
                                                    type={'delete'} permission={'delete-collector'}/>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                        <Col sm='12' lg='9'>
                            <Card className='hovercard'>
                                <CardBody>
                                    <BootstrapTabContainer>
                                        <BootstrapTabContent title={'Dashboard'} icon={"icofont icofont-dashboard"}>
                                            {collector && <CollectorDashboard collector={collector}/>}
                                        </BootstrapTabContent>

                                        {hasPermission && hasPermission('read-board') && (
                                            <BootstrapTabContent title={'Boards'} icon={'icofont icofont-ui-calendar'}>
                                                <BoardsTable params={{collector_id: collector?.id}}/>
                                            </BootstrapTabContent>
                                        )}

                                        {hasPermission && hasPermission('read-participant') && (
                                            <BootstrapTabContent title={'Participants'}
                                                                 icon={'icofont icofont-ui-user-group'}>
                                                <ParticipantsTable params={{collector_id: collector?.id}}
                                                                   tableOptions={{view: true}}/>
                                            </BootstrapTabContent>
                                        )}

                                        {hasPermission && hasPermission('read-contact') && (
                                            <BootstrapTabContent title={'Contacts'}
                                                                 icon={'icofont icofont-contact-add'}>
                                                <div className='d-flex justify-content-end mb-3'>
                                                    {collector?.id && <ButtonIcon
                                                        attrBtn={{onClick: () => setContactModalVisibility(true)}}
                                                        type={'add'}
                                                        permission={'create-contact'}
                                                    />}
                                                </div>
                                                <ContactTable
                                                    ref={contactTableRef}
                                                    params={{related_key: 'collector', related_id: collector?.id}}
                                                    related_key={'collector'}
                                                    related_id={collector?.id}
                                                    onEdit={openContactEditModal}
                                                />
                                            </BootstrapTabContent>
                                        )}
                                        {
                                            collector?.cash_wallet_id && hasPermission && hasPermission('read-wallet-transaction') && (
                                                <BootstrapTabContent title={'Cash'}
                                                                     icon={'icofont icofont-bank-transfer'}>
                                                    <WalletTransactionsTable
                                                        params={{wallet_id: collector?.cash_wallet_id}}/>
                                                </BootstrapTabContent>
                                            )
                                        }
                                        {
                                            collector?.point_wallet_id && hasPermission && hasPermission('read-wallet-transaction') &&
                                            <BootstrapTabContent title={'Point'}
                                                                 icon={'icofont icofont-bank-transfer'}>
                                                <WalletTransactionsTable
                                                    params={{wallet_id: collector?.point_wallet_id}}/>
                                            </BootstrapTabContent>
                                        }
                                        {hasPermission && hasPermission('confirm-wallet-transaction') && (
                                            <BootstrapTabContent title={'Confirmations'}
                                                                 icon={'icofont icofont-check-alt'}>
                                                <WalletTransactionsTable
                                                    params={{collector_id: collector?.id, status: 'unconfirmed'}}
                                                    tableOptions={{confirm: true}}/>
                                            </BootstrapTabContent>
                                        )}
                                        {hasPermission && hasPermission('read-multimedia') && (
                                            <BootstrapTabContent title={'Multimedia'} icon={'icofont icofont-check-alt'}>
                                                <MultimediaTable
                                                    params={{link_type_key: 'collector', link_type_id: collector?.id}}/>
                                            </BootstrapTabContent>
                                        )}
                                        {hasPermission && hasPermission('update-collector') && (
                                            <BootstrapTabContent title={'Update'} icon={'icofont icofont-ui-edit'}>
                                                <UpdateUserForm userData={collector?.user}/>
                                            </BootstrapTabContent>
                                        )}

                                        {hasPermission && hasPermission('read-activity-log') && (
                                            <BootstrapTabContent title={'Activity Log'} icon={'icofont icofont-list'}>
                                                {collector &&
                                                    <ActivityLog subjectType="collector" subjectId={collector.id}/>}
                                            </BootstrapTabContent>
                                        )}

                                    </BootstrapTabContainer>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </div>
            </Container>
            {collector ? (
                <Modal isOpen={contactModalVisibility} toggle={contactModalToggle} centered>
                    <ModalHeader>{selectedContact ? 'Update' : 'Create'} Contact</ModalHeader>
                    <ModalBody>
                        <ContactForm
                            callBack={addContact}
                            contact={selectedContact}
                            related_key={'collector'}
                            related_id={collector.id}
                        />
                    </ModalBody>
                    <ModalFooter>
                        <Btn attrBtn={{color: 'primary', onClick: contactModalToggle}}>Close</Btn>
                    </ModalFooter>
                </Modal>
            ) : null}
        </div>
    );
}

export default CollectorShow;
